'use client';

import { cx, css } from 'styled-system/css';
import { Icon, TicketSuccessLineIcon } from '@/components/icons/svg-icons';
import { defaultStakeStyle } from './default-stake.style';
import { BetDefaultStakeType } from '@/services/account.service';
import { StakeKeypad } from '../stake-keypad';
import { StakeInput } from '../stake-input';
import { useDefaultStake } from './use-default-stake';

type DefaultStakeProps = {
	from: 'quick-settings' | 'me' | 'betslip'
}

// 使用部分
// galaxy : bet setting modal
// mars : bet setting modal / quicky setting / me page
export const DefaultStake = ({ from }: DefaultStakeProps) => {
	const {
		defaultStakeList,
		selectedId,
		changeSelectedId,
		inputStake,
		isInputFocus,
		toggleInput,
		isInputSelected,
		setSelectKey,
		onNumberPress,
		onBackspacePress,
		saveCustomize,
		setInputStake
	} = useDefaultStake(from);

	return (
		<div className={defaultStakeStyle.root}>
			{defaultStakeList?.map(item => {
				const isActive = selectedId === item.id;
				return (
					<div
						key={item.id}
						data-active={isActive}
						className={cx(
							defaultStakeStyle.item
						)}
					>
						<div
							className={defaultStakeStyle.row}
							onClick={changeSelectedId(item.id)}
						>
							<div className={defaultStakeStyle.rowRadio}>
								<Icon name={isActive ? 'radio-on' : 'radio'} />
							</div>
							<div>{item.text}</div>
							{isActive ?  (
								<div className={cx(defaultStakeStyle.rowControl)}>
									<TicketSuccessLineIcon />
								</div>
							) : null
							}
						
						</div>

						{item.id === BetDefaultStakeType.Customize ? (
							<div className={cx(
								defaultStakeStyle.content,
								css({ display: isActive ? 'block' : 'none' })
							)}
							>
								<StakeInput
									inputValue={inputStake}
									setInputValue={(input: number) => setInputStake(input)}
									isFocus={isInputFocus}
									setFocusKey={toggleInput}
									isSelect={isInputSelected}
									setSelectKey={setSelectKey}
								/>
								<StakeKeypad
									isOpen={isInputFocus}
									onNumberPress={onNumberPress}
									onBackspacePress={onBackspacePress}
									clickDone={saveCustomize}
								/>
							</div>
						) : null}
					</div>
				)
			})}
		</div>
	)
}